// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a1e7a6e4","453":"195ce187"}[chunkId] + ".chunk.js";
};